// apps/web/src/components/shell/indicador-ao-vivo.tsx — Fase 17.8, Plano 12 (D-13; UI-SPEC U-25).
// Indicador da topbar (data-testid="painel-ao-vivo"): ponto de 8px + texto Label "Atualizado há 12 s", recalculado a cada 10 s.
// O texto NÃO é aria-live (mudaria a cada 10 s); uma região role="status" oculta anuncia uma única vez a mudança para atenção
// (reconectando, sem atualização). Sem `ultimaAtualizacao` (telas que não registram) não renderiza nada. Os números da tela
// nunca somem quando a conexão cai: o indicador só avisa.
import { useEffect, useState, type ReactElement } from 'react';
import { estadoDeAtencao, INTERVALO_INDICADOR_MS, textoIndicador, type EstadoAoVivo } from '../../lib/painel/home/ao-vivo';
import { useCanalAoVivo } from './ao-vivo-provider';

/** Frase lida uma vez pelo leitor de tela quando o estado vira atenção. */
const ANUNCIO_DO_ESTADO: Readonly<Partial<Record<EstadoAoVivo, string>>> = {
  reconectando: 'Atualização ao vivo interrompida. Reconectando.',
  'sem-atualizacao': 'Os dados podem estar desatualizados.',
  'nao-autorizado': 'A atualização ao vivo foi encerrada. Entre novamente se os dados não atualizarem.',
};

export function IndicadorAoVivo(): ReactElement | null {
  const { estado, ultimaAtualizacao } = useCanalAoVivo();
  const [, setRelogio] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setRelogio((n) => n + 1), INTERVALO_INDICADOR_MS);
    return () => clearInterval(id);
  }, []);

  if (ultimaAtualizacao === null) return null;
  const atencao = estadoDeAtencao(estado);
  const texto = textoIndicador(estado, ultimaAtualizacao, new Date());
  return (
    <div className="topbar-ao-vivo" data-testid="painel-ao-vivo" data-estado={estado} title={texto}>
      <span className="topbar-ao-vivo__ponto" data-atencao={atencao ? 'true' : undefined} aria-hidden="true" />
      <span className="topbar-ao-vivo__texto num">{texto}</span>
      <span role="status" className="sr-only">
        {atencao ? ANUNCIO_DO_ESTADO[estado] : ''}
      </span>
    </div>
  );
}
